import React, { useState, useEffect } from 'react';
import {
    Container,
    Typography,
    Box,
    Button,
    TextField,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Alert,
    Tabs,
    Tab
} from '@mui/material';
import axios from 'axios';
import api from '../api';
import config from '../config';
import UserResults from './UserResults';

const Dashboard = () => {
    const [openChangePasswordDialog, setOpenChangePasswordDialog] = useState(false);
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [userRole, setUserRole] = useState('user');
    const [activeTab, setActiveTab] = useState(0);

    useEffect(() => {
        fetchUserRole();
    }, []);

    const fetchUserRole = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`${config.apiBaseUrl}/admin/user`, {
                headers: { 'x-access-token': token },
            });
            setUserRole(response.data.role);
        } catch (err) {
            console.error('Ошибка при получении роли пользователя:', err);
        }
    };

    const handleChangePassword = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await api.post(
                `${config.apiBaseUrl}/auth/change-password`,
                { oldPassword, newPassword },
                { headers: { 'x-access-token': token } }
            );
            setSuccess('Пароль успешно изменен');
            setError('');
            setOpenChangePasswordDialog(false);
        } catch (err) {
            setError(err.response?.data?.message || 'Ошибка при изменении пароля');
            setSuccess('');
        }
    };



    // Для обычных пользователей показываем вкладки: результаты и смена пароля
    return (
        <Container maxWidth="lg">
            <Tabs
                value={activeTab}
                onChange={(e, newValue) => setActiveTab(newValue)}
                sx={{ mb: 3 }}
            >
                <Tab label="Результаты проверки" />
                <Tab label="Настройки аккаунта" />
            </Tabs>

            {activeTab === 0 ? (
                <UserResults />
            ) : (
                <Box>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => setOpenChangePasswordDialog(true)}
                        sx={{ mb: 3 }}
                    >
                        Сменить пароль
                    </Button>

                    <Dialog
                        open={openChangePasswordDialog}
                        onClose={() => setOpenChangePasswordDialog(false)}
                    >
                        <DialogTitle>Смена пароля</DialogTitle>
                        <DialogContent>
                            {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
                            {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}
                            <TextField
                                fullWidth
                                label="Старый пароль"
                                type="password"
                                value={oldPassword}
                                onChange={(e) => setOldPassword(e.target.value)}
                                sx={{ mt: 2 }}
                            />
                            <TextField
                                fullWidth
                                label="Новый пароль"
                                type="password"
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                                sx={{ mt: 2 }}
                            />
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setOpenChangePasswordDialog(false)}>Отмена</Button>
                            <Button onClick={handleChangePassword} color="primary">
                                Сохранить
                            </Button>
                        </DialogActions>
                    </Dialog>
                </Box>
            )}
        </Container>
    );
};

export default Dashboard;